import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/gewichtenbl";

const GewichtenBLApi = {
    get()
    {
        const serviceUrl = prependRoot(routePrefix, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
    }
};

export default GewichtenBLApi;
